import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Success() {
  const navigate = useNavigate();

  useEffect(() => {
    // onboarding-v2 is deprecated - redirect to QR page for mobile app onboarding
    navigate("/login/qr", { replace: true });
  }, [navigate]);

  return <div>Redirecting...</div>;
}

export default Success;
